import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { useSelector } from 'react-redux';

import env from 'Env';
import 'Components/BundleCarousel/BundleCarouselReviewScore.scss';

const getReviewData = (critic, threshold, theme) => {
  if (critic && get(critic, 'score') >= threshold) {
    return {
      score: get(critic, 'score', 0),
      imgSrc: `https://cdn.fanatical.com/production/brand/${critic.name}/svg/${critic.name}-full-${theme === 'light' ? 'black' : 'white'}.svg`,
      imgAlt: critic.name,
    };
  }
  return null;
};

const BundleCarouselReviewScore = ({ openCritic, metaCritic }) => {
  const recommendedThreshold = env.percentRecommendedThreshold;
  const theme = useSelector(state => state.siteTheme) || 'dark';

  const metaCriticData = getReviewData({ ...metaCritic, name: 'metacritic' }, recommendedThreshold, theme);
  const openCriticData = getReviewData({ ...openCritic, name: 'opencritic' }, recommendedThreshold, theme);

  const reviewData = metaCriticData || openCriticData;

  if (!reviewData) return null;

  return (
    <div className="BundleCarouselReviewScore">
      <div className="BundleCarouselReviewScore__reviewScore">
        {reviewData.score}
      </div>
      <div className="BundleCarouselReviewScore__reviewIcon">
        <img
          width="100px"
          src={reviewData.imgSrc}
          alt={reviewData.imgAlt}
        />
      </div>
    </div>
  );
};

BundleCarouselReviewScore.propTypes = {
  openCritic: PropTypes.shape({
    score: PropTypes.number,
  }),
  metaCritic: PropTypes.shape({
    score: PropTypes.number,
  }),
};

BundleCarouselReviewScore.defaultProps = {
  openCritic: null,
  metaCritic: null,
};

export default BundleCarouselReviewScore;
